define("shared/components/shared/run-task", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/debug", "@ember/service", "@ember-data/model", "@glimmer/component", "ember-concurrency", "reactiveweb/ember-concurrency", "shared/utils/hash-code", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _debug, _service, _model, _component2, _emberConcurrency, _emberConcurrency2, _hashCode, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/service",0,"@ember-data/model",0,"@glimmer/component",0,"ember-concurrency",0,"reactiveweb/ember-concurrency",0,"shared/utils/hash-code",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="shared-run-task">
    {{yield this.runTask this.last.value this.inProgress}}
  </div>
  */
  {
    "id": "VpLD3K1v",
    "block": "[[[10,0],[14,0,\"shared-run-task\"],[12],[1,\"\\n  \"],[18,1,[[30,0,[\"runTask\"]],[30,0,[\"last\",\"value\"]],[30,0,[\"inProgress\"]]]],[1,\"\\n\"],[13]],[\"&default\"],false,[\"yield\"]]",
    "moduleName": "shared/components/shared/run-task.hbs",
    "isStrictMode": false
  });

  /**
   * @class RunTask
   * @extends Component
   *
   * This component runs any ember-concurrency task on insert or update of args and yields
   * the task which contains all of it's derived state.  It can optionally cache the last result.
   *
   * Required Arguments:
   * - cache (Boolean) Whether the last task result should be cached
   *
   * Optional Arguments:
   * - cacheMinutes (Boolean) The time in minutes to cache the last task result. Defaults to 5.
   * - taskArgs (Object) Arguments or list of arguments to run with task.
  
   *
   * Examples:
   *
   * Block Usage:
   * ```
   * <Shared::RunTask
   *   @task={{this.myTask}}
   *   @taskArgs={{this.socialProfile}}
   *   @cache={{true}}
   *   as
   *   |task lastResult isRunning|
   * >
   *   <Ui::Simple
   *     @data={{lastResult}}
   *     @isRunning={{isRunning}}
   *     @socialProfile={{this.socialProfile}}
   *   />
   * </Shared::RunTask>
   * ```
   */

  const stringifyWithCircularReferences = obj => {
    const seenObjects = new WeakSet();
    return JSON.stringify(obj, (key, value) => {
      if (typeof value === 'object' && value !== null) {
        if (seenObjects.has(value)) {
          // Replace circular reference with a custom value
          return '[Circular]';
        }
        seenObjects.add(value);
      }
      return value;
    });
  };
  let RunTaskComponent = _exports.default = (_class = class RunTaskComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "cache", _descriptor, this);
      _defineProperty(this, "runTask", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          (false && !(typeof this.args.task === 'object') && (0, _debug.assert)('call RunTask with a {Task} task argument', typeof this.args.task === 'object')); // taskArgs may change so copy it to a local variable
          const taskArgs = this.taskArgsAsArray;
          if (this.cacheKey) {
            const cachedValue = this.cache.retrieve(this.cacheKey);
            if (cachedValue) {
              return cachedValue;
            }
          }
          const value = yield this.args.task.perform(...taskArgs);
          if (this.cacheKey && this.cacheMinutes && value !== undefined) {
            this.cache.add(this.cacheKey, value, {
              expiry: this.cache.expiry(this.cacheMinutes, 'minutes')
            });
          }
          return value;
        }
      }), null, "runTask", null));
      _defineProperty(this, "last", (0, _emberConcurrency2.task)(this, this.runTask, () => this.taskArgsAsArray));
    }
    get taskArgsAsArray() {
      const {
        taskArgs
      } = this.args;
      return Array.isArray(taskArgs) ? taskArgs : [taskArgs];
    }
    get cacheKey() {
      (false && !(typeof this.args.cache === 'boolean') && (0, _debug.assert)('call RunTask with a {Boolean} cache argument', typeof this.args.cache === 'boolean'));
      if (this.args.cache) {
        const arrayOfArgs = this.taskArgsAsArray.map(arg => {
          if (arg instanceof _model.default) {
            return arg.serialize();
          }
          return stringifyWithCircularReferences(arg);
        });
        const encodedArgs = (0, _hashCode.default)(JSON.stringify(arrayOfArgs));
        const key = `${this.args.task.name}_${encodedArgs}`;
        return key;
      }
      return undefined;
    }
    get cacheMinutes() {
      const defaultMinutes = 5;
      return this.args.cacheMinutes || defaultMinutes;
    }
    get inProgress() {
      return this.last.isRunning || !this.runTask.performCount || this.runTask.isRunning;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, RunTaskComponent);
});